import { render, staticRenderFns } from "./TestItem.vue?vue&type=template&id=a511f6ba&"
import script from "./TestItem.vue?vue&type=script&lang=js&"
export * from "./TestItem.vue?vue&type=script&lang=js&"
import style0 from "./TestItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports